import { State, Selector } from "./types";
import { combineStateReducer } from "../utils/combineStateReducer";

import * as createCalendarHolidays from "./createCalendarHolidays";
import * as retrieveCalendarsHolidays from "./retrieveCalendarsHolidays";
import * as removeCalendarHolidays from "./removeCalendarHolidays";
import * as editCalendarHolidays from "./editCalendarHolidays";
import * as removeHoliday from "./removeHoliday";

const initialState: State = {
  createCalendarHolidays: createCalendarHolidays.initialState,
  retrieveCalendarsHolidays: retrieveCalendarsHolidays.initialState,
  removeCalendarHolidays: removeCalendarHolidays.initialState,
  editCalendarHolidays: editCalendarHolidays.initialState,
  removeHoliday: removeHoliday.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createCalendarHolidays: createCalendarHolidays.reduceState,
  retrieveCalendarsHolidays: retrieveCalendarsHolidays.reduceState,
  removeCalendarHolidays: removeCalendarHolidays.reduceState,
  editCalendarHolidays: editCalendarHolidays.reduceState,
  removeHoliday: removeHoliday.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createCalendarHolidays.createSelector(
      () => getState().createCalendarHolidays,
    ),
    ...retrieveCalendarsHolidays.createSelector(
      () => getState().retrieveCalendarsHolidays,
    ),
    ...removeCalendarHolidays.createSelector(
      () => getState().removeCalendarHolidays,
    ),
    ...editCalendarHolidays.createSelector(
      () => getState().editCalendarHolidays,
    ),
    ...removeHoliday.createSelector(() => getState().removeHoliday),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
